import { createClient } from '@/shared/api';
import MARK_REPORT_ARTIFACT_MUTATION from '@/entities/report/api/mutations/markReportAsArtifactReport';
import type {
  MarkReportAsArtifactReportMutation,
  MarkReportAsArtifactReportMutationVariables,
} from '@/shared/api/generated/graphql';

export type MarkReportAsArtifactReportResult = {
  isSuccess: boolean;
  message: string;
};

/**
 * Flags a report as an artifact report, or clears that flag. Runs the mutation and throws the server message when it reports failure.
 *
 * @param id - Identifier of the report.
 * @param isArtifactReport - Whether the report should be marked as an artifact report.
 * @returns A promise resolving once the artifact flag has been stored.
 */
const handleMarkReportAsArtifactReport = async (id: string, isArtifactReport: boolean) => {
  const client = await createClient();
  const result = await client.mutate<
    MarkReportAsArtifactReportMutation,
    MarkReportAsArtifactReportMutationVariables
  >({
    mutation: MARK_REPORT_ARTIFACT_MUTATION,
    variables: {
      id,
      isArtifactReport,
    },
  });
  const { data } = result;
  const { markReportAsArtifactReport } = data;
  if (!markReportAsArtifactReport.isSuccess) {
    throw new Error(markReportAsArtifactReport.message);
  }
};

export default handleMarkReportAsArtifactReport;
